import React, {useCallback, useContext, useEffect, useRef} from 'react';
import {addToClickedFilters, fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from '../../ArticleOverviewHelper';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import {useBreakpointUp} from "bonprix-design-system";

function Tiled({filterOptionChange, identifier, trackingId, filterOptions}) {

    const filterWrapper = useRef(null);
    const clickedFilters = useRef(fillInitialClickedFilters(filterOptions));

    const handleClick = useCallback((event, option) => {
        event.preventDefault();
        clickedFilters.current = addToClickedFilters(option.value, clickedFilters.current);
        yieldToMain(() => filterOptionChange(identifier, trackingId, clickedFilters.current));
    }, []);

    return (
        <div className="filter__tiled" ref={filterWrapper}>
            {filterOptions.map((option, index) => {
                return renderFilterOption(option, index);
            })}
        </div>
    );

    function renderFilterOption(option, index) {
        return (
            <div className="filter__option -tiled" key={index}>
                <input className="filter__tiled-input" type="checkbox"/>
                <label className="filter__tiled-input-label">{renderLinkElement(option)}</label>
            </div>
        );
    }

    function renderLinkElement(option) {
        const selected = clickedFilters.current.includes(option.value) ? 'is-selected' : '';
        const tiledButtonClasses = `filter__tiled-button ${selected}`;

        return option.seoHref ? (
            <a className={tiledButtonClasses} onClick={(event) => handleClick(event, option)} href={option.seoHref}>
                {option.name}
            </a>
        ) : (
            <div className={tiledButtonClasses} onClick={(event) => handleClick(event, option)}>
                {option.name}
            </div>
        );
    }

}

export default React.memo(Tiled);
